import { useCallback } from 'react';
import BroadcastQueueItem from './BroadcastQueueItem';
import S from './BroadcastQueueStyles';
import type { BroadcastQueueItem as BroadcastQueueItemType, AbortBroadcastParams } from './types';

type Props = {
  fleetId: string | null;
  items: BroadcastQueueItemType[];
  expandedId: string | null;
  onToggle: (id: string) => void;
  onAbort: (params: AbortBroadcastParams) => void;
  playingId: string | null;
  onPlayPause: (itemId: string, isPlaying: boolean) => void;
  isAbortLoading?: boolean;
};

export default function BroadcastQueueAccordion({
  fleetId,
  items,
  expandedId,
  onToggle,
  onAbort,
  playingId,
  onPlayPause,
  isAbortLoading = false,
}: Props): JSX.Element {
  const handleToggle = useCallback(
    (id: string) => (): void => {
      onToggle(id);
    },
    [onToggle],
  );

  return (
    <S.AccordionList>
      {items.map((item) => (
        <BroadcastQueueItem
          key={item.id}
          fleetId={fleetId}
          item={item}
          isExpanded={expandedId === item.id}
          onToggle={handleToggle(item.id)}
          onAbort={onAbort}
          playingId={playingId}
          onPlayPause={onPlayPause}
          isAbortLoading={isAbortLoading}
        />
      ))}
    </S.AccordionList>
  );
}
